export default __webpack_public_path__ + "74abd9c4b216aabc28736bb1c55414cf.png";